'use strict';
var React = require('react');
var IconParts = require('../common/IconParts');
var _ = require('underscore');

var Icon = React.createClass({
  render: function () {
    var props = _.extend({}, this.props);
    props.x = props.y = 0;
    delete props.currentX;
    delete props.currentY;
    return (<IconParts {...props}/>);
  }
});

module.exports = Icon;



// WEBPACK FOOTER //
// ./src/views/Components/Icon.jsx